/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS202: Simplify dynamic range loops
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
export default {

    extend(dest, ...objs) {
        for (let obj of Array.from(objs)) {
            for (let k in obj) { const v = obj[k]; dest[k] = v; }
        }
        return dest;
    },

    windowWidth() {
        return window.innerWidth || this.window.width();
    },

    debounce(func, wait, immediate) {
        let timeout = null;
        return function() {
            const context = this;
            const args = arguments;

            const later = function() {
                timeout = null;
                if (!immediate) {
                    func.apply(context, args);
                }
            };

            const callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);

            if (callNow) {
                func.apply(context, args);
            }
        };
    },

    inViewport(el) {
        // special bonus for those using jQuery
        if ((typeof jQuery === "function") && el instanceof jQuery) {
            el = el[0];
        }

        const rect = el.getBoundingClientRect();

        const bounds = {
            top: rect.top >= 0,
            bottom: rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
        };

        return bounds.top && bounds.bottom;
    },

    unique(array) {
        let key;
        let asc, end;
        const output = {};
        for (key = 0, end = array.length, asc = 0 <= end; asc ? key < end : key > end; asc ? key++ : key--) { output[array[key]] = array[key]; }
        return (() => {
            const result = [];
            for (key in output) {
                const value = output[key];
                result.push(value);
            }
            return result;
        })();
    }
};
